/* Skånevik Fjordhotel logo – vector traced from the supplied brand files.
   Text + boat follow `currentColor`; the wave keeps the brand light-blue (#b9d3ec). */

const Mark = () => (
  <>
    <g transform="translate(0,320) scale(0.1,-0.1)" fill="#b9d3ec" stroke="none">
      <path d="M4475 2080 c-33 -16 -123 -59 -200 -96 -77 -37 -196 -93 -265 -126
-318 -152 -1072 -404 -1395 -467 -28 -6 -115 -24 -195 -41 -349 -74 -596 -107
-900 -121 -406 -19 -765 -2 -948 45 -84 22 -113 26 -107 15 15 -23 202 -165
220 -166 12 -1 59 -9 105 -17 210 -40 794 -47 1035 -12 889 129 2025 481 2370
736 160 118 365 273 365 276 0 10 -30 0 -85 -26z" />
    </g>
    <g transform="translate(0,320) scale(0.1,-0.1)" fill="currentColor" stroke="none">
      <path d="M5031 3067 c-97 -49 -149 -363 -92 -550 13 -42 22 -79 20 -82 -3 -2
-115 -57 -249 -121 l-245 -116 -345 -1 c-513 -1 -880 31 -1915 169 -849 112
-1024 157 -1176 300 -96 90 -112 88 -202 -32 -70 -93 -172 -192 -394 -381
-393 -337 -442 -424 -350 -618 190 -398 618 -716 1228 -914 69 -22 272 -77
450 -121 363 -91 396 -100 844 -245 712 -231 922 -275 1240 -262 533 24 931
244 1341 742 277 337 717 1017 717 1108 0 61 -285 291 -556 449 l-47 28 0 57
c0 134 -82 455 -141 552 -29 47 -80 63 -128 38z m43 -328 c59 -317 79 -722 47
-939 -30 -201 -139 -652 -203 -840 -183 -534 -534 -770 -1143 -770 -287 0
-551 55 -1010 208 l-170 57 260 6 c585 15 1143 90 1557 209 230 67 278 89 264
125 -8 22 -36 19 -145 -15 -157 -48 -389 -91 -801 -149 -634 -89 -1148 -109
-1440 -56 -85 16 -670 152 -676 158 -2 2 63 9 144 15 593 47 1433 250 2032
490 556 223 1212 614 1144 682 -7 7 -41 -9 -100 -46 -553 -352 -1224 -632
-1949 -813 -962 -240 -1405 -285 -1744 -174 -217 70 -566 279 -676 404 l-20
22 20 -7 c251 -99 783 -109 1330 -25 598 92 1363 300 2025 552 319 121 1149
486 1238 543 28 18 26 32 -19 141 -40 98 -46 169 -24 289 21 118 26 112 59
-67z m-4108 -148 c109 -130 323 -188 1114 -301 887 -127 1473 -183 2009 -193
l124 -2 -135 -58 c-736 -313 -1810 -611 -2493 -691 -727 -86 -1214 2 -1376
249 -128 194 -92 266 295 599 193 166 372 341 410 399 22 33 22 33 52 -2z
m4327 -277 c141 -71 487 -325 504 -371 6 -15 -24 -76 -125 -253 -77 -135 -71
-131 -131 -79 -64 56 -137 101 -237 144 l-79 35 5 87 c3 49 5 172 5 276 0 103
1 187 3 187 1 0 26 -12 55 -26z m-4 -657 c124 -61 241 -153 241 -188 0 -27
-284 -422 -409 -569 -94 -110 -214 -241 -217 -237 -2 2 9 28 25 58 55 101 158
447 241 804 38 168 38 165 46 165 3 0 36 -15 73 -33z" />
    </g>
  </>
);

const Wordmark = () => (
  <g transform="translate(0,175) scale(0.1,-0.1)" fill="currentColor" stroke="none">
      <path d="M2530 1660 c-113 -22 -181 -120 -159 -232 4 -24 8 -46 9 -50 1 -17
72 -86 99 -97 l28 -12 -109 -277 c-60 -152 -161 -410 -225 -572 -63 -162 -117
-301 -120 -308 -4 -9 11 -12 53 -12 l59 0 51 133 51 132 289 5 c159 3 292 3
297 0 4 -4 30 -64 57 -134 27 -71 51 -131 54 -133 2 -2 28 -3 58 -1 l54 3 -99
260 c-54 143 -155 404 -223 580 -115 294 -124 321 -107 330 211 117 116 431
-117 385z m116 -114 c28 -28 34 -42 34 -76 0 -138 -170 -174 -219 -46 -44 116
98 209 185 122z m49 -743 l123 -328 -129 -3 c-72 -1 -185 -1 -253 0 l-122 3
108 290 c59 160 115 309 124 333 9 24 18 41 21 38 3 -2 60 -152 128 -333z" />
      <path d="M280 1266 c-229 -67 -314 -303 -167 -463 53 -58 99 -83 226 -127 229
-80 291 -134 291 -258 -1 -220 -268 -306 -563 -183 -16 7 -18 2 -15 -46 l3
-53 60 -19 c139 -44 345 -33 458 24 193 99 234 361 78 502 -51 46 -90 66 -253
127 -190 71 -243 122 -242 228 1 67 39 125 104 162 70 38 218 41 320 6 41 -14
79 -27 85 -28 6 -2 10 18 10 47 l-1 50 -54 19 c-71 24 -275 31 -340 12z" />
      <path d="M10830 1264 c-295 -78 -474 -411 -404 -751 54 -262 227 -410 495
-421 195 -8 304 31 425 152 241 241 240 691 -2 905 -129 114 -340 161 -514
115z m320 -110 c201 -96 300 -338 245 -598 -65 -308 -351 -464 -622 -341 -333
151 -324 772 13 935 106 52 259 53 364 4z" />
      <path d="M15881 1264 c-353 -95 -526 -558 -344 -918 37 -73 135 -167 213 -204
161 -77 375 -73 531 9 264 140 375 543 232 847 -34 74 -149 189 -223 225 -117
56 -288 74 -409 41z m332 -117 c237 -117 322 -456 185 -735 -151 -306 -596
-321 -751 -25 -112 215 -76 520 82 682 123 127 321 159 484 78z" />
      <path d="M1110 685 l0 -585 55 0 55 0 0 278 0 277 97 -100 c53 -55 175 -180
271 -277 l175 -178 70 0 69 0 -173 180 c-96 99 -225 235 -288 301 l-114 120
284 285 284 284 -70 0 -70 0 -267 -267 -268 -268 0 268 0 267 -55 0 -55 0 0
-585z" />
      <path d="M3378 685 l-3 -585 52 0 53 0 2 497 3 497 135 -199 c128 -189 246
-360 460 -663 l93 -132 59 0 58 0 0 585 0 585 -55 0 -55 0 3 -500 c1 -275 -1
-500 -4 -500 -3 0 -33 42 -67 93 -70 107 -311 457 -497 722 l-130 185 -52 0
-53 0 -2 -585z" />
      <path d="M4725 685 l0 -585 313 0 312 0 0 40 0 40 -137 2 c-246 5 -287 6 -330
7 l-43 1 0 225 0 225 220 0 220 0 0 45 0 45 -47 1 c-27 1 -126 1 -220 0 l-173
-1 0 225 0 225 250 0 250 0 0 45 0 45 -307 0 -308 0 0 -585z" />
      <path d="M5552 1253 c6 -19 174 -473 256 -688 27 -71 78 -205 113 -297 l64
-168 63 0 c55 0 64 3 72 22 8 20 226 557 395 973 78 193 77 175 7 175 l-59 0
-126 -322 c-123 -314 -277 -717 -277 -724 0 -2 -4 -4 -10 -4 -5 0 -10 5 -10
12 0 6 -40 122 -89 257 -49 135 -129 354 -176 486 -48 132 -92 252 -97 268 -9
25 -14 27 -70 27 -53 0 -60 -2 -56 -17z" />
      <path d="M6850 685 l0 -585 55 0 55 0 0 585 0 585 -55 0 -55 0 0 -585z" />
      <path d="M7400 685 l0 -585 55 0 55 0 0 275 c0 155 4 275 9 275 5 0 24 -17 42
-37 17 -21 137 -145 266 -276 l233 -238 69 3 69 3 -284 294 c-156 161 -284
298 -284 303 0 5 127 135 283 288 l282 280 -70 0 -70 0 -265 -265 c-146 -146
-268 -265 -272 -265 -5 0 -8 119 -8 265 l0 265 -55 0 -55 0 0 -585z" />
      <path d="M8980 685 l0 -585 55 0 55 0 0 270 0 270 226 0 225 0 -3 48 -3 47
-220 0 -220 0 -3 223 -2 222 255 0 255 0 0 45 0 45 -310 0 -310 0 0 -585z" />
      <path d="M9988 797 l-3 -473 -25 -49 c-36 -69 -92 -99 -175 -91 -33 2 -68 8
-78 11 -15 6 -17 1 -17 -38 0 -55 5 -59 90 -65 99 -7 172 17 231 76 82 83 83
85 87 630 l3 472 -55 0 -55 0 -3 -473z" />
      <path d="M11878 685 l-3 -585 57 0 58 0 2 261 3 260 216 -238 c120 -131 225
-249 235 -261 17 -21 26 -23 86 -20 l68 3 -132 145 c-72 80 -180 199 -240 265
-59 66 -108 123 -108 127 0 5 22 8 50 8 219 0 380 133 380 315 0 213 -151 305
-502 305 l-168 0 -2 -585z m341 495 c148 -25 221 -96 221 -216 0 -156 -116
-234 -347 -234 l-103 0 0 230 0 230 83 0 c45 0 111 -5 146 -10z" />
      <path d="M12940 685 l0 -587 233 5 c320 6 416 35 552 172 111 111 155 220 162
395 12 304 -125 496 -412 576 -45 13 -117 18 -297 21 l-238 5 0 -587z m493
476 c227 -59 339 -211 338 -461 -1 -360 -221 -540 -623 -514 l-98 7 0 493 0
494 153 0 c119 0 171 -4 230 -19z" />
      <path d="M14240 685 l0 -585 58 0 58 0 0 268 1 267 334 0 334 0 0 -267 0 -268
58 0 57 0 0 585 0 585 -57 0 -58 0 0 -268 0 -267 -335 0 -335 0 -3 268 -2 267
-55 0 -55 0 0 -585z" />
      <path d="M16750 1225 l0 -45 160 0 160 0 0 -540 0 -540 58 0 57 0 0 453 c-1
248 1 491 4 540 l4 87 163 0 164 0 0 45 0 45 -385 0 -385 0 0 -45z" />
      <path d="M17840 685 l0 -585 315 0 315 0 0 40 0 40 -260 0 -260 0 0 230 0 230
224 0 224 0 4 46 c2 32 -1 48 -10 51 -7 3 -92 3 -190 1 -97 -3 -194 -3 -214 0
l-38 4 0 219 0 219 260 0 260 0 0 45 0 45 -315 0 -315 0 0 -585z" />
      <path d="M18840 685 l0 -585 311 0 310 0 -3 43 -3 42 -120 1 c-66 0 -180 1
-252 2 l-133 2 0 540 0 540 -55 0 -55 0 0 -585z" />
  </g>
);

/** Horizontal lock-up: mark left, wordmark right (viewBox 2493 × 260) */
export const LogoHorizontal = ({ className = "h-6", title = "Skånevik Fjordhotel", ...rest }) => (
  <svg viewBox="0 0 2493 260" role="img" aria-label={title} className={`${className} w-auto`} {...rest}>
    <g transform="scale(0.8125)"><Mark /></g>
    <g transform="translate(543,46)"><Wordmark /></g>
  </svg>
);

/** Stacked lock-up: mark above wordmark (viewBox 1950 × 505) */
export const LogoStacked = ({ className = "h-14", title = "Skånevik Fjordhotel", ...rest }) => (
  <svg viewBox="0 0 1950 505" role="img" aria-label={title} className={`${className} w-auto`} {...rest}>
    <g transform="translate(614,0)"><Mark /></g>
    <g transform="translate(0,330)"><Wordmark /></g>
  </svg>
);

/** Boat + wave mark only (viewBox 595 × 320) */
export const LogoMark = ({ className = "h-6", title = "Skånevik Fjordhotel", ...rest }) => (
  <svg viewBox="0 0 595 320" role="img" aria-label={title} className={`${className} w-auto`} {...rest}>
    <Mark />
  </svg>
);
